import z from "zod/v4";
import { TenantIdCodec, SiteIdCodec, AssetIdCodec, CameraIdCodec } from "@visioni/a3s-schema/codecs";

/** A single camera within an asset's camera set. */
export const CameraEntry = z.object({
  camera: CameraIdCodec,
  friendlyName: z.string().nullable(),
});
export type CameraEntry = z.infer<typeof CameraEntry>;

/** The complete camera set for one installed asset. */
export const CameraChange = z.object({
  action: z.literal("set"),
  tenant: TenantIdCodec,
  site: SiteIdCodec,
  asset: AssetIdCodec,
  cameras: z.array(CameraEntry),
});
export type CameraChange = z.infer<typeof CameraChange>;
